import { useLastPathSegment } from 'shared/hooks'
import { useAddNumberFromAppStepsContext } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppStepsContext'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useAddNumberFromAppStepsContext()

  return getProgressInfoTitle(useLastPathSegment())
}
